import alt, { AltActions } from '../../alt';
import APIRequest from '../../api_request';
import URLHelpers from '../../shared/url_helpers';

interface Actions {
  loadAllFeedback(shopSlug: string);
  loadFeedbackSummary(shopSlug: string);
  loaded(response: any);
  loadMore(url: string);
  loadSellerFeedback(shopSlug: string);
  loadBuyerFeedback(shopSlug: string);
  summaryLoaded(response: any);
}

const PER_PAGE = 5;

class FeedbackActions extends AltActions implements Actions {
  request(url) {
    APIRequest.V3.get(url)
      .then((response) => {
        this.loaded(response);
      })
      .fail((err) => {
        throw (err);
      });

    return null;
  }

  loadAllFeedback(shopSlug) {
    const url = URLHelpers.feedbackApiPath(shopSlug, { per_page: PER_PAGE });
    this.request(url);

    return null;
  }

  loadSellerFeedback(shopSlug) {
    const url = URLHelpers.sellerFeedbackApiPath(shopSlug, { per_page: PER_PAGE });
    this.request(url);

    return null;
  }

  loadBuyerFeedback(shopSlug) {
    const url = URLHelpers.buyerFeedbackApiPath(shopSlug, { per_page: PER_PAGE });
    this.request(url);

    return null;
  }

  loadFeedbackSummary(shopSlug) {
    const url = URLHelpers.feedbackSummaryApiPath(shopSlug);

    APIRequest.V3.get(url)
      .then((response) => {
        this.summaryLoaded(response);
      })
      .fail((err) => {
        throw (err);
      });

    return null;
  }

  loadMore(url) {
    APIRequest.V3.get(url)
      .then((response) => {
        this.loaded(response);
      })
      .fail((err) => {
        throw (err);
      });

    return null;
  }

  loaded(response) {
    return response;
  }

  summaryLoaded(response) {
    return response;
  }
}

export default alt.createActions(FeedbackActions);
